import * as actionTypes from '../types/settings';

const initialState = {
  loading: false,
  settings: {},
  holderSettings: {},
  message: {
    loading: false,
    data: [],
    listPhotos: [],
    okPhoto: false,
    okPhotoAdd: false,
    okPhotoDelete: false,
    create: {
      template: {
        nextNumber: null,
        okRequest: false,
        loading: false
      },
      loading: false,
      okRequest: false
    },
    read: {
      loading: false,
      okRequest: false
    }
  }
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_SETTINGS_PLANT:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_SETTINGS_PLANT_SUCCESS:
      return {
        ...state,
        loading: false,
        settings: payload
      };
    case actionTypes.GET_SETTINGS_PLANT_FAIL:
      return {
        ...state,
        loading: false
      };

    case actionTypes.SET_SETTINGS_PLANT:
      return {
        ...state,
        loading: true
      };
    case actionTypes.SET_SETTINGS_PLANT_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case actionTypes.SET_SETTINGS_PLANT_FAIL:
      return {
        ...state,
        loading: false
      };

    /** Работа с сообщениями */
    case actionTypes.MESSAGE_CLEAR:
      return {
        ...state,
        message: {
          ...state.message,
          loading: false,
          create: {
            ...state.message.create,
            loading: false,
            okRequest: false
          }
        }
      };
    case actionTypes.MESSAGE_SAVE:
      return {
        ...state,
        message: {
          ...state.message,
          create: {
            ...state.message.create,
            loading: true,
            okRequest: false
          }
        }
      };
    case actionTypes.MESSAGE_SAVE_SUCCESS:
      return {
        ...state,
        message: {
          ...state.message,
          create: {
            ...state.message.create,
            loading: false,
            okRequest: true
          }
        }
      };
    case actionTypes.MESSAGE_SAVE_FAIL:
      return {
        ...state,
        message: {
          ...state.message,
          create: {
            ...state.message.create,
            loading: false
          }
        }
      };
    case actionTypes.MESSAGE_DELETE:
      return {
        ...state,
        message: {
          ...state.message,
          loading: true
        }
      };
    case actionTypes.MESSAGE_DELETE_SUCCESS:
      return {
        ...state,
        message: {
          ...state.message,
          loading: false
        }
      };
    case actionTypes.MESSAGE_DELETE_FAIL:
      return {
        ...state,
        message: {
          ...state.message,
          loading: false
        }
      };
    case actionTypes.MESSAGE_LIST:
      return {
        ...state,
        message: {
          ...state.message,
          loading: true
        }
      };
    case actionTypes.MESSAGE_LIST_SUCCESS:
      return {
        ...state,
        message: {
          ...state.message,
          loading: false,
          data: payload
        }
      };
    case actionTypes.MESSAGE_LIST_FAIL:
      return {
        ...state,
        message: {
          ...state.message,
          loading: false
        }
      };
    /** Получение параметров для holder_report */
    case actionTypes.GET_HOLDER_SETTINGS_PLANT:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_HOLDER_SETTINGS_PLANT_SUCCESS:
      return {
        ...state,
        loading: false,
        holderSettings: payload
      };
    case actionTypes.GET_HOLDER_SETTINGS_PLANT_FAIL:
      return {
        ...state,
        loading: false
      };
    case actionTypes.MESSAGE_TEMPLATE:
      return {
        ...state,
        message: {
          ...state.message,
          create: {
            ...state.message.create,
            template: {
              ...state.message.create.template,
              loading: true
            }
          }
        }
      };
    case actionTypes.MESSAGE_TEMPLATE_SUCCESS:
      return {
        ...state,
        message: {
          ...state.message,
          create: {
            ...state.message.create,
            template: {
              ...state.message.create.template,
              loading: false,
              okRequest: true,
              nextNumber: payload
            }
          }
        }
      };
    case actionTypes.MESSAGE_TEMPLATE_FAIL:
      return {
        ...state,
        message: {
          ...state.message,
          create: {
            ...state.message.create,
            template: {
              ...state.message.create.template,
              loading: false,
              okRequest: false
            }
          }
        }
      };
    case actionTypes.MESSAGE_FILES_ADD_SUCCESS:
      return {
        ...state,
        message: {
          ...state.message,
          okPhotoAdd: true
        }
      };
    case actionTypes.MESSAGE_FILES_ADD_FAIL:
      return {
        ...state,
        message: {
          ...state.message,
          listPhotos: [],
          okPhotoAdd: false
        }
      };
    case actionTypes.MESSAGE_FILES_LIST_SUCCESS:
      return {
        ...state,
        message: {
          ...state.message,
          listPhotos: payload,
          okPhoto: true
        }
      };
    case actionTypes.MESSAGE_FILES_LIST_FAIL:
      return {
        ...state,
        message: {
          ...state.message,
          listPhotos: [],
          okPhoto: false
        }
      };
    case actionTypes.MESSAGE_FILES_DELETE_SUCCESS:
      return {
        ...state,
        message: {
          ...state.message,
          okPhotoDelete: true
        }
      };
    case actionTypes.MESSAGE_FILES_DELETE_FAIL:
      return {
        ...state,
        message: {
          ...state.message,
          okPhotoDelete: false
        }
      };
    case actionTypes.MESSAGE_OK_PHOTO_INIT:
      return {
        ...state,
        message: {
          ...state.message,
          okPhoto: false,
          okPhotoAdd: false,
          okPhotoDelete: false
        }
      };
    case actionTypes.MESSAGE_READ:
      return {
        ...state,
        message: {
          ...state,
          read: {
            ...state,
            loading: true
          }
        }
      };
    case actionTypes.MESSAGE_READ_SUCCESS:
      return {
        ...state,
        message: {
          ...state,
          read: {
            loading: false,
            okRequest: true
          }
        }
      };
    case actionTypes.MESSAGE_READ_FAIL:
      return {
        ...state,
        message: {
          ...state,
          read: initialState.message.read
        }
      };

    default:
      return state;
  }
};

export default reducer;
